import { useState } from "react";
import { ThemeContext } from "./ThemeContext";

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState({
    gradientBlue: "linear-gradient(93.43deg, #5926f0 -0.29%, #33168a 97.87%)",
    colorAccent: "#ff69b4",
    colorPrimary: "#5926F0",
    fontzalando: "zalando, sans-serif",
    logo: "/assets/images/logo.png",
  });

  const updateTheme = (newTheme) => {
    setTheme((prev) => ({ ...prev, ...newTheme }));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, updateTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
